import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const DoubleThumbsUpSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default DoubleThumbsUpSVG;
